import script from "./ShopifyRunHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopifyRunHistory.vue?vue&type=script&setup=true&lang=js"

import "./ShopifyRunHistory.vue?vue&type=style&index=0&id=175b2842&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175b2842"]])

export default __exports__